// HamburgerButton.js
import React from 'react';
import styled from 'styled-components';

const Button = styled.button`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 100;

  &:focus {
    outline: none;
  }

  div {
    width: 2rem;
    height: 0.25rem;
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
    background: #fff;

    :first-child {
      transform: ${({ $isOpen }) => ($isOpen ? 'rotate(45deg)' : 'rotate(0)')};
    }

    :nth-child(2) {
      opacity: ${({ $isOpen }) => ($isOpen ? '0' : '1')};
      transform: ${({ $isOpen }) => ($isOpen ? 'translateX(20px)' : 'translateX(0)')};
    }

    :nth-child(3) {
      transform: ${({ $isOpen }) => ($isOpen ? 'rotate(-45deg)' : 'rotate(0)')};
    }
  }
`;

const Line = styled.div`
  width: 24px;
  height: 2px;
  background-color: rgba(255, 255, 255, 0.9);
  margin: 4px 0;
  transition: all 0.3s ease;
  
  &:nth-child(1) {
    transform: ${props => props.$isOpen ? 'rotate(45deg) translate(5px, 5px)' : 'none'};
  }

  &:nth-child(2) {
    opacity: ${props => props.$isOpen ? '0' : '1'};
  }

  &:nth-child(3) {
    transform: ${props => props.$isOpen ? 'rotate(-45deg) translate(5px, -5px)' : 'none'};
  }
`;

const HamburgerButton = ({ isOpen, toggle }) => {
  return (
    <Button $isOpen={isOpen} onClick={toggle}>
      <div />
      <div />
      <div />
    </Button>
  );
};

export default HamburgerButton;
